<template>
  <div>
    <CRow>
      <CCol>
        <CCard>
          <CCardBody>
            <CForm>
              <CTabs>
                <CTab>
                  <template slot="title">
                    <CIcon name="cil-bookmark" /> Dados de Cadastro
                  </template>
                  <br />
                  <CInput v-model="salas.sala" placeholder="" prepend="SALA" invalid-feedback="* Campo obrigatório">
                    <template #append-content>
                      <CIcon name="cil-badge" />
                    </template>
                  </CInput>
                  <CInput v-model="salas.andar" prepend="ANDAR" autocomplete="andar"
                    invalid-feedback="* Campo obrigatório">
                    <template #append-content>
                      <CIcon name="cil-bank" />
                    </template>
                  </CInput>

                  <CButton @click="postSala()" color="success">Cadastrar</CButton>
                  <CButton style="margin-left: 10px" color="info" @click="voltar()">Voltar</CButton>
                </CTab>
              </CTabs>
            </CForm>
          </CCardBody>
          <CCardBody>
            <CAlert color="danger" id="aviso" name="aviso" :show.sync="validacoes.aviso" closeButton>{{
              validacoes.msg
            }}</CAlert>
            <CAlert color="success" id="sucesso" name="sucesso" :show.sync="validacoes.sucesso" closeButton>{{
              validacoes.msg
            }}</CAlert>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>
<script>
export default {
  name: "CadastrarSalas",
  data() {
    return {
      validacoes: {
        sucesso: false,
        aviso: false,
        msg: "",
      },
      items: [],
      status: false,
      salas: {
        sala: "",
        andar: "",
      },
    };
  },
  methods: {
    listarSalas() {
      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}salas`)
        .then((res) => res.json())
        .then((res) => {
          this.items = res;
        });
    },
    postSala() {
      //create a function for sum 2 values
      this.$http
        .post(`${process.env.VUE_APP_API_BASE_URL}salas/cadastro`, {
          salas: this.salas,
        })
        .then((res) => {
          if (res.status == 203) {
            this.validacoes.msg = "Sala já cadastrada";
            this.validacoes.aviso = true;
            setTimeout(() => {
              this.validacoes.aviso = false;
            }, 1000);
          } else {
            this.validacoes.sucesso = true;
            this.validacoes.msg = "Cadastro efetuado com sucesso";
            setTimeout(() => {
              this.$router.push("/salas");
            }, 1000);
          }

        });
    },
    cadastrarSala() {
      if (this.salas.sala && this.salas.andar) {
        this.$http
          .get(`${process.env.VUE_APP_API_BASE_URL}salas/${this.salas.sala}`)
          .then((res) => res.json())
          .then((res) => {
            

            let status = false;
            res.forEach((item) => {
              if (item.sala == this.salas.sala) {
                status = true;
              }
            });
            if (!status) {
              this.postSala();
            } else {
              this.validacoes.msg = "Sala já cadastrada";
              this.validacoes.aviso = true;
              setTimeout(() => {
                this.validacoes.aviso = false;
              }, 1000);
            }
          });
      } else {
        this.validacoes.aviso = true;
        this.validacoes.msg = "Preencha todos campos corretamente";
        setTimeout(() => {
          this.validacoes.aviso = false;
        }, 3000);
      }
    },
    voltar() {
      this.$router.push("/salas");
    },
  },

  mounted() {
    this.listarSalas();
  },
};
</script>
